import '../../../Modals/XpektorBootstrapModal.scss';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import UserService from '../../../../../Services/UserService';
import {
  XpektorForm,
  FormInput,
  FormDropdown,
  FormButton,
} from '../../../../../Components/XpektorForms/XpektorForms';
import Regex from '../../../../../Components/Utilities/Regex';

const gT = (t, key) => t(`modal.create-user${key}`);
const gsT = (t, key) => t(`shared${key}`);

/* eslint-disable react/prop-types */
export default function CreateUserModal({ handleClose, onCreated, t }) {
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState(1);
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');

  const requiredText = gsT(t, '.errors.empty-field');
  const invalidEmailText = gsT(t, '.errors.invalid-email');
  const [creating, setCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newNameError = '';
    let newEmailError = '';
    let hasError = false;

    const tmpUserName = userName.trim();
    const tmpUserEmail = userEmail.trim();

    if (tmpUserName.length === 0) {
      newNameError = requiredText;
      hasError = true;
    }

    if (!Regex.testEmail(tmpUserEmail)) {
      newEmailError = invalidEmailText;
      hasError = true;
    }

    if (hasError) {
      setNameError(newNameError);
      setEmailError(newEmailError);
      return;
    }

    const currentUser = UserService.getCurrentUser();
    const newUser = {
      customerId: currentUser.customerId,
      email: tmpUserEmail,
      name: tmpUserName,
      role: Number(userRole),
    };

    setCreating(true);
    await UserService.CreateUser(newUser)
      .then(async (response) => {
        await onCreated(response.data);
        handleClose();
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setEmailError(gT(t, '.error.email-already-used'));
        } else {
          setEmailError(gT(t, '.error.general'));
        }
      })
      .finally(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{gT(t, '.modal-title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{gT(t, '.description')}</p>
        <XpektorForm onSubmit={handleSubmit}>
          <FormInput
            label={gT(t, '.form-input-label.name')}
            value={userName}
            onChange={(e) => {
              if (e.target.value.length > 0) setNameError('');
              else setNameError(requiredText);
              setUserName(e.target.value);
            }}
            infoText={nameError}
            maxLength={100}
          />
          <FormInput
            label={gsT(t, '.labels.email')}
            value={userEmail}
            onChange={(e) => {
              if (e.target.value.length === 0) {
                setEmailError(requiredText);
              } else if (!Regex.testEmail(e.target.value)) {
                setEmailError(invalidEmailText);
              } else {
                setEmailError('');
              }
              setUserEmail(e.target.value);
            }}
            infoText={emailError}
            maxLength={100}
          />
          <FormDropdown
            label={gsT(t, '.labels.user-role')}
            defaultValue={1}
            onChange={(e) => setUserRole(e.target.value)}
          >
            <option value={0}>{gsT(t, '.user-roles.user')}</option>
            <option value={1}>{gsT(t, '.user-roles.admin')}</option>
          </FormDropdown>
          <FormButton
            text={
              creating
                ? gsT(t, '.actions.creating')
                : gT(t, '.form-btn.create-user')
            }
            disabled={creating}
          />
        </XpektorForm>
      </Modal.Body>
    </Modal>
  );
}
